"use strict";

var _Reflect$construct = require("@babel/runtime-corejs2/core-js/reflect/construct");
var _Object$keys = require("@babel/runtime-corejs2/core-js/object/keys");
var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");
var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors");
var _Object$defineProperties = require("@babel/runtime-corejs2/core-js/object/define-properties");
var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));
var _promise = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/promise"));
var _stringify = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/json/stringify"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));
var _webexCore = require("@webex/webex-core");
var _loggerProxy = _interopRequireDefault(require("../common/logs/logger-proxy"));
var _constants = require("../constants");
var _util = _interopRequireDefault(require("../meeting/util"));
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } } // @ts-ignore
/**
 * @class RoapRequest
 */
var RoapRequest = exports.default = /*#__PURE__*/function (_StatelessWebexPlugin) {
  (0, _inherits2.default)(RoapRequest, _StatelessWebexPlugin);
  var _super = _createSuper(RoapRequest);
  function RoapRequest() {
    (0, _classCallCheck2.default)(this, RoapRequest);
    return _super.apply(this, arguments);
  }
  (0, _createClass2.default)(RoapRequest, [{
    key: "sendRoap",
    value: (
    /**
     * Sends a ROAP message
     * @param {Object} options
     * @param {Object} options.roapMessage
     * @param {String} options.locusSelfUrl
     * @param {String} options.mediaId
     * @param {String} options.correlationId
     * @param {String} options.meetingId
     * @returns {Promise} returns the response/failure of the request
     */
    function () {
      var _sendRoap = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(options) {
        var _clientMediaPreferenc, _clientMediaPreferenc2;
        var roapMessage, locusSelfUrl, isMultistream, mediaId, locusMediaRequest, reachability, clientMediaPreferences;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              roapMessage = options.roapMessage, locusSelfUrl = options.locusSelfUrl, isMultistream = options.isMultistream, mediaId = options.mediaId, locusMediaRequest = options.locusMediaRequest;
              if (!mediaId) {
                _loggerProxy.default.logger.info('Roap:request#sendRoap --> sending empty mediaID');
              }
              if (locusMediaRequest) {
                _context.next = 5;
                break;
              }
              _loggerProxy.default.logger.warn('Roap:request#sendRoap --> locusMediaRequest unavailable, not sending roap');
              return _context.abrupt("return", _promise.default.reject(new Error('sendRoap called when locusMediaRequest is undefined')));
            case 5:
              clientMediaPreferences = {
                // bare minimum fallback value that should allow us to join;
                joinCookie: undefined,
                ipver: _constants.IP_VERSION.unknown,
                preferTranscoding: !isMultistream
              };
              _context.prev = 6;
              _context.next = 9;
              return this.webex.meetings.reachability.getClientMediaPreferences(isMultistream,
              // @ts-ignore
              _util.default.getIpVersion(this.webex));
            case 9:
              clientMediaPreferences = _context.sent;
              _context.next = 12;
              return this.webex.meetings.reachability.getReachabilityReportToAttachToRoap();
            case 12:
              reachability = _context.sent;
              _context.next = 18;
              break;
            case 15:
              _context.prev = 15;
              _context.t0 = _context["catch"](6);
              _loggerProxy.default.logger.error('Roap:request#sendRoap --> reachability error:', _context.t0);
            case 18:
              _loggerProxy.default.logger.info("Roap:request#sendRoap --> ".concat(roapMessage.messageType, " seq:").concat(roapMessage.seq, " ").concat((_clientMediaPreferenc = clientMediaPreferences) !== null && _clientMediaPreferenc !== void 0 && _clientMediaPreferenc.ipver ? "ipver=".concat((_clientMediaPreferenc2 = clientMediaPreferences) === null || _clientMediaPreferenc2 === void 0 ? void 0 : _clientMediaPreferenc2.ipver, " ") : '', " ").concat(locusSelfUrl));
              return _context.abrupt("return", locusMediaRequest.send({
                type: 'RoapMessage',
                selfUrl: locusSelfUrl,
                mediaId: mediaId,
                roapMessage: roapMessage,
                reachability: reachability,
                clientMediaPreferences: clientMediaPreferences
              }).then(function (res) {
                // always it will be the first mediaConnection Object
                var mediaConnections = res.body.mediaConnections && res.body.mediaConnections.length > 0 && res.body.mediaConnections[0];
                _loggerProxy.default.logger.debug("Roap:request#sendRoap --> response:".concat((0, _stringify.default)(mediaConnections, null, 2), "'\n StatusCode:'").concat(res.statusCode));
                var locus = res.body.locus;
                locus.roapSeq = options.roapMessage.seq;
                return _objectSpread({
                  locus: locus
                }, mediaConnections && {
                  mediaConnections: res.body.mediaConnections
                });
              }).catch(function (err) {
                _loggerProxy.default.logger.error("Roap:request#sendRoap --> Error:", err);
                _loggerProxy.default.logger.error("Roap:request#sendRoapRequest --> roapMessage that caused error:".concat((0, _stringify.default)(roapMessage, null, 2), " + '\\n mediaId:'").concat(options.mediaId));
                throw err;
              }));
            case 20:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[6, 15]]);
      }));
      function sendRoap(_x) {
        return _sendRoap.apply(this, arguments);
      }
      return sendRoap;
    }())
  }]);
  return RoapRequest;
}(_webexCore.StatelessWebexPlugin);
//# sourceMappingURL=request.js.map
